import React, { ReactNode } from "react";
import {
  CancellationReason,
  FormattedPlanDetails,
  FormattedPlanDetailsMapping,
} from "@shared/types";
import { CancellationStep } from "@shared/features/settings/subscription/types";

export const CancelSubscriptionContext = React.createContext<
  | {
      step: CancellationStep;
      setStep: (step: CancellationStep) => void;
      onNextClick: () => void;
      isLoadingCancelSubscription: boolean;
      reason: CancellationReason | undefined;
      setReason: (reason?: CancellationReason) => void;
      otherReasonDescription: string;
      setOtherReasonDescription: (otherReasonDescription: string) => void;
      isInvalidReasonDescription?: boolean;
      plans?: FormattedPlanDetailsMapping;
      currentDiscount?: number;
      plan: FormattedPlanDetails | undefined;
      isLoading?: boolean;
      onBackButtonClick?: () => void;
      getBackButton: () => ReactNode;
    }
  | undefined
>(undefined);
